import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import OrderManagementApiService from './OrderManagementApiService';
import { GET_BULK_ORDER_GRID_COUNT, GET_BULK_ORDER_GRID_DATA } from 'Store/OrderManagement/BulkOrderDashboard/BulkOrderDashboardType';
import { setBulkOrderGridCount, setBulkOrderGridData, setIsBulkOrderGridCountsLoading, setIsBulkOrderGridLoading } from 'Store/OrderManagement/BulkOrderDashboard/BulkOrderDashboardAction';
import { IPayload } from 'Model/IPayload';
import { API_URL, apiMethod, apiType } from 'utils';

function* getBulkOrderGridCount(): any {
    yield put(setIsBulkOrderGridCountsLoading(true))
    try {
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint : `orders/grid/requisition/bulkorder/count`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData);
        yield put(setBulkOrderGridCount(response))
        yield put(setIsBulkOrderGridCountsLoading(false))
    } catch (error) {
        yield put(setBulkOrderGridCount([]))
        yield put(setIsBulkOrderGridCountsLoading(false))
    }
}

function* getBulkOrderGridData(payload: any): any {
    yield put(setIsBulkOrderGridLoading(true))
    try {
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint : `orders/grid/requisition/bulkorder`,
            apiMethod : apiMethod.POST,
            payload : payload?.payload
        }
        const response = yield call(OrderManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setBulkOrderGridData(response))
        yield put(setIsBulkOrderGridLoading(false))
    } catch (error) {
        yield put(setBulkOrderGridData([]))
        yield put(setIsBulkOrderGridLoading(false))
    }
}

function* watchGetRequestType() {
    yield takeEvery(GET_BULK_ORDER_GRID_COUNT, getBulkOrderGridCount)
    yield takeLatest(GET_BULK_ORDER_GRID_DATA, getBulkOrderGridData)
}

export default function* combinedSaga() {
    yield all([
        watchGetRequestType()
    ])
}